import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["ratio", "borderColor", "children", "extraComponent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { c as s } from "../clsx-OuTLNxxd.js";
import { ImageRatio as c } from "../ImageRatio/ImageRatio.js";
import { R as g } from "../ResponsiveSanityImage-BfPbiFwC.js";
import { c as _ } from "../background-bUl5ds8G.js";
import { i as u } from "../utils-NCUO6j8v.js";
const B = "BaseCard-module_base-card__EtAZn",
  C = "BaseCard-module_text-align-left__upi5s",
  f = "BaseCard-module_text-align-center__76VdN",
  N = "BaseCard-module_title__j4oYV",
  b = "BaseCard-module_body__NU-4c",
  x = "BaseCard-module_footer__GqEPU",
  y = "BaseCard-module_image__C7fPH",
  p = "BaseCard-module_image-border-neutral05__VMJ-z",
  h = "BaseCard-module_image-border-neutral35__SRXSi",
  A = "BaseCard-module_image-footer__m4zSh",
  t = {
    baseCard: B,
    textAlignLeft: C,
    textAlignCenter: f,
    title: N,
    body: b,
    footer: x,
    image: y,
    imageBorderNeutral05: p,
    imageBorderNeutral35: h,
    imageFooter: A
  },
  F = _ref => {
    let {
      children: a,
      extraComponent: e,
      ratio: d,
      borderColor: o
    } = _ref;
    return /* @__PURE__ */i("div", {
      className: s(t.image, {
        [t.imageBorderNeutral05]: o == "neutral05",
        [t.imageBorderNeutral35]: o == "neutral35"
      }),
      children: [/* @__PURE__ */r(c, {
        ratio: d,
        children: a
      }), e]
    });
  },
  L = _ref2 => {
    let {
        ratio: a,
        borderColor: e,
        children: d,
        extraComponent: o
      } = _ref2,
      n = _objectWithoutProperties(_ref2, _excluded);
    return /* @__PURE__ */i(F, {
      ratio: a,
      borderColor: e,
      extraComponent: o,
      children: [u(n.image) && /* @__PURE__ */r(g, _objectSpread(_objectSpread({}, n), {}, {
        defaultWidth: 400,
        defaultHeight: 600,
        draggable: !1,
        loading: "lazy"
      })), d]
    });
  },
  P = _ref3 => {
    let {
      className: a,
      children: e
    } = _ref3;
    return /* @__PURE__ */r("h3", {
      className: s(t.title, a),
      children: e
    });
  },
  V = _ref4 => {
    let {
      className: a,
      children: e
    } = _ref4;
    return /* @__PURE__ */r("div", {
      className: s(t.imageFooter, a),
      children: e
    });
  },
  E = _ref5 => {
    let {
      className: a,
      children: e
    } = _ref5;
    return /* @__PURE__ */r("div", {
      className: s(t.body, a),
      children: e
    });
  },
  H = _ref6 => {
    let {
      className: a,
      children: e
    } = _ref6;
    return /* @__PURE__ */r("footer", {
      className: s(t.footer, a),
      children: e
    });
  },
  U = _ref7 => {
    let {
      background: a = "transparent",
      textAlign: e = "left",
      className: d,
      trackingName: o,
      children: n,
      style: l
    } = _ref7;
    const m = _(a);
    return /* @__PURE__ */r("article", {
      className: s(t.baseCard, d, m, {
        [t.textAlignLeft]: e == "left",
        [t.textAlignCenter]: e == "center"
      }),
      "data-content-name": o,
      style: l,
      children: n
    });
  };
export { U as BaseCard, E as BaseCardBody, H as BaseCardFooter, F as BaseCardImage, V as BaseCardImageFooter, L as BaseCardSanityImage, P as BaseCardTitle };